import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './QuestionnairreResponse.scss';
import {getQuestionnaireDetails} from 'Apis/caseDataAPI.js';

export class QuestionnairreResponse extends Component {  
     constructor(props) {
       super(props);
       this.state = {
         questionnaireData: [],
       };
       
     }
     attachBindings() {
          this.questionnaireData = this.questionnaireData.bind(this);
     }   
    
getQuestionnaireData = (stageId) => {
     getQuestionnaireDetails(stageId).then((response) => {
          this.setState({
            questionnaireData: response.data
          });
        }).catch((error) => {
          console.log('Error occured while fetching questionnaire response', error);
        });
};
      
  buttonName = 'View Questionnaire Details';
  
render(){
return(<div className = "questionnaire-section-card">        
       <span className="questionnaire-view">
       <button onClick={() =>{this.openDrawer(this.props.listItem.eventHeaderDetails.responseToCaseStageId,6,(this.props.listItem.eventHeaderDetails.responseToCaseStageId))}}className="button-questionnaire-view button-view">{this.buttonName}</button>
       </span>
         
</div>)
}

openDrawer = (caseStageId,id, stageId) => {
  this.props.getApiDrawerData(caseStageId, id, stageId);
  this.props.toggleDrawer(true,id);
}


}
export default QuestionnairreResponse;